module.exports = __webpack_public_path__ + "img/blockables-instructions-5.1d91b5a8.png";